import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { initializeGoogleAnalytics, trackPageView } from '../../analytics/ga4'

const GoogleAnalytics = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        if (!initializeGoogleAnalytics()) return

        const frame = window.requestAnimationFrame(() => {
            trackPageView(pathname, document.title)
        })

        return () => window.cancelAnimationFrame(frame)
    }, [pathname])

    return null
}

export default GoogleAnalytics
